<template>
    <div class="cookie-pop">
        <div class="pop-mask" @click="closePop"></div>
        <div class="cookie-pop-con">
            <div class="wp">
                <div class="left">
                    {{$t('cookie.desc')}}.<a href="">{{$t('cookie.link')}}</a>
                </div>
                <div class="right">
                    <div class="small-btn hollow" @click="closePop">{{$t('cookie.btn1')}}</div>
                    <div class="small-btn" @click="closePop">{{$t('cookie.btn2')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "cookiePop",
    methods:{
        closePop:function () {
            this.$emit('close')
        }
    }
}
</script>

<style scoped lang="scss">
//cookie-pop

.cookie-pop{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10000;
}
.cookie-pop-con{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 40px 0;
    background-color: #fff;
    box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.25);
    .wp{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left{
            @extend .sub1-18px;
            flex:0 0 878px;
            a{
                text-decoration: underline;
                margin-left: 5px;
            }
        }
        .right .small-btn{
            width: 190px;
            height: 36px;
        }
        .small-btn+.small-btn{
            margin-top: 16px;
        }
    }
}
@media only screen and (max-width: 1199px) {
    .cookie-pop-con .wp .left{
        flex:0 0 60%
    }
}
@media only screen and (max-width: 767px) {
    .cookie-pop-con .wp{
        display: block;
    }
    .cookie-pop-con .wp .left{
        font-size: 12px;
        font-weight: normal;
    }
    .cookie-pop-con .right{
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .cookie-pop-con .wp .small-btn+.small-btn{
        margin-top: 0;
        margin-left: 10px;
    }
}
</style>
